document.addEventListener("DOMContentLoaded", () => {
  try {
    const el = document.getElementById("ds-shipdate");
    if (!el) return;

    // Tåler "3", "3 virkedager", "3-5", osv.
    const raw = String(el.dataset.days || "");
    const m = raw.match(/\d+/);
    const daysToAdd = m ? parseInt(m[0], 10) : NaN;

    if (Number.isNaN(daysToAdd)) {
      console.warn("Ugyldig leveringstid (data-days):", raw);
      return;
    }

    const from = el.dataset.from || "Bergen";

    let d = new Date();
    let added = 0;

    while (added < daysToAdd) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay(); // 0=søn, 6=lør
      if (day !== 0 && day !== 6) added++;
    }

    const formatted = d.toLocaleDateString("no-NO", { day: "numeric", month: "long" });

  const isBestilling = daysToAdd > 3;

const prefix = isBestilling
  ? `Bestillingsvare – sendes fra ${from} innen`
  : `Sendes fra ${from} innen`;

const colorClass = isBestilling ? "ds-dot--orange" : "ds-dot--green";

el.innerHTML = `
  <span class="ds-dot ${colorClass}"></span>
  ${prefix} ${formatted} (${daysToAdd} virkedager)
`;


  } catch (err) {
    console.error("ds-shipdate.js krasjet:", err);
  }
});
